var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClass2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2596 6.82772H1.16797V0.40625H12.2596V6.82772Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.759766 0.408639C0.759766 0.182954 0.942719 0 1.1684 0H12.26C12.4857 0 12.6687 0.182954 12.6687 0.408639V6.8301C12.6687 7.05579 12.4857 7.23874 12.26 7.23874H1.1684C0.942719 7.23874 0.759766 7.05579 0.759766 6.8301V0.408639ZM1.57704 0.817277V6.42147H11.8514V0.817277H1.57704Z",
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19531 4.84614C5.19531 4.62045 5.37827 4.4375 5.60395 4.4375H10.2741C10.4998 4.4375 10.6827 4.62045 10.6827 4.84614V6.83096C10.6827 7.05664 10.4998 7.23959 10.2741 7.23959H5.60395C5.37827 7.23959 5.19531 7.05664 5.19531 6.83096V4.84614ZM6.01259 5.25478V6.42232H9.86547V5.25478H6.01259Z",
    fill: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.83334C0 6.44645 0.313635 6.13281 0.700524 6.13281H12.7262C13.1131 6.13281 13.4267 6.44645 13.4267 6.83334V9.40192C13.4267 9.78881 13.1131 10.1024 12.7262 10.1024H0.700524C0.313635 10.1024 0 9.78881 0 9.40192V6.83334ZM1.40105 7.53386V8.7014H12.0257V7.53386H1.40105Z",
    fill: "#EFEFEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33894 8.80007C4.66803 9.00351 4.76989 9.4352 4.56646 9.76428L2.58164 12.975C2.3782 13.3041 1.94651 13.406 1.61743 13.2025C1.28834 12.9991 1.18648 12.5674 1.38992 12.2383L3.37473 9.02758C3.57817 8.6985 4.00986 8.59664 4.33894 8.80007Z",
    fill: "#EFEFEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97639 8.79714C8.64568 8.99793 8.54036 9.42879 8.74115 9.75949L10.726 13.0286C10.9268 13.3593 11.3576 13.4646 11.6883 13.2638C12.019 13.0631 12.1244 12.6322 11.9236 12.3015L9.93875 9.03238C9.73796 8.70167 9.3071 8.59635 8.97639 8.79714Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass2);
export default __webpack_public_path__ + "static/media/Class2.4f5a3999e9bd1d4be47a82257e0940b0.svg";
export { ForwardRef as ReactComponent };